import { useEffect } from 'react';

import { brandPalette, DEFAULT_BRAND } from '@/utils/brandPalette';
import { currentMembership, useTenantStore } from './tenantStore';

const BRAND_VARS = ['--brand', '--brand-hover', '--brand-soft', '--brand-soft-hover', '--brand-ink'];

/**
 * Applies the active tenant's accent color by overriding the `--brand*` CSS
 * variables on the document root. When there's no tenant accent — or it's the
 * product default — the inline overrides are removed so the hand-tuned tokens in
 * styles/tokens.css apply. Mounted once in the app shell (__root).
 */
export function useTenantTheme(): void {
  const accent = useTenantStore((s) => currentMembership(s)?.accentColor);

  useEffect(() => {
    const root = document.documentElement;
    const palette =
      accent && accent.toLowerCase() !== DEFAULT_BRAND ? brandPalette(accent) : null;

    if (!palette) {
      BRAND_VARS.forEach((v) => root.style.removeProperty(v));
      return;
    }

    root.style.setProperty('--brand', palette.brand);
    root.style.setProperty('--brand-hover', palette.brandHover);
    root.style.setProperty('--brand-soft', palette.brandSoft);
    root.style.setProperty('--brand-soft-hover', palette.brandSoftHover);
    root.style.setProperty('--brand-ink', palette.brandInk);

    return () => {
      BRAND_VARS.forEach((v) => root.style.removeProperty(v));
    };
  }, [accent]);
}
